export default __webpack_public_path__ + "static/media/hero-image-4.cac42305.svg";